import React from 'react';
import { Lock } from 'lucide-react';
import SolutionDrawer from './SolutionDrawer';

const RISK_META = {
  high: { color: 'bg-red-500/15 text-red-300 border-red-500/40', label: 'High Risk' },
  medium: { color: 'bg-yellow-500/15 text-yellow-300 border-yellow-500/40', label: 'Medium' },
  low: { color: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30', label: 'Low' },
};

/**
 * ActionQueueTable — READ-ONLY in Phase 1.
 * Approve/Reject buttons shown but disabled with Phase-2 tooltip.
 * Props:
 *   actions: ProposedAction[]
 */
export default function ActionQueueTable({ actions, onStatusChange }) {
  const items = actions || [];

  return (
    <div className="rounded-xl bg-[#0a0820]/70 border border-gold/25 overflow-hidden" data-testid="growth-os-action-queue">
      <div className="px-4 py-3 border-b border-gold/15 flex items-center justify-between">
        <div>
          <div className="font-heading text-lg text-text-main">Proposed Actions Queue</div>
          <div className="text-xs text-text-muted">Har issue par expand kar ke AI Solution Preview / Approve / Reject / Edit</div>
        </div>
        <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-semibold uppercase tracking-widest bg-white/5 text-text-muted border border-white/10">
          <Lock className="w-3 h-3" /> No Auto-Execute
        </span>
      </div>

      {items.length === 0 ? (
        <div className="p-6 text-center text-text-muted text-sm">
          कोई proposed action अभी queue में नहीं है। अगला audit चलने के बाद updates मिलेंगे।
        </div>
      ) : (
        <div className="max-h-[700px] overflow-y-auto divide-y divide-white/5">
          {items.map((a) => {
            const meta = RISK_META[a.risk_level] || RISK_META.low;
            return (
              <div key={a.action_id} data-testid={`action-row-${a.action_id}`}>
                <div className="px-4 py-3 flex items-start gap-3 hover:bg-white/5 transition-colors">
                  <div className="flex-1 min-w-0">
                    <div className="text-text-main font-medium text-sm">{a.title}</div>
                    {a.linked_finding?.route && (
                      <div className="text-[11px] text-text-muted mt-0.5">
                        {a.linked_finding.route} · {a.estimated_impact || '—'}
                      </div>
                    )}
                  </div>
                  <span className="text-[10px] text-text-muted uppercase tracking-widest hidden md:inline whitespace-nowrap">
                    {a.category}
                  </span>
                  <span className={`inline-block px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-widest border ${meta.color} whitespace-nowrap`}>
                    {meta.label}
                  </span>
                </div>
                <SolutionDrawer action={a} onStatusChange={onStatusChange} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
